/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import { CarouselComponent, CarouselItemsDirective, CarouselItemDirective } from '@syncfusion/ej2-react-navigations';
import * as React from 'react';
import Navbar from './Navbar1';
import slide1 from '../data/slide1.png';
import slide2 from '../data/slide2.png';
import slide3 from '../data/slide3.png';
import slide0 from '../data/slide0.png';

const NewHome = () => {
  const slide0Content = () => (
    <figure className="img-container">
      <img src={slide0} alt="heat stres" style={{ height: '800px', width: '100%' }} />
      <figcaption className="img-caption">Heat Stress</figcaption>
    </figure>
  );
  const slide1Content = () => (
    <figure className="img-container">
      <img src={slide1} alt="cardinal" style={{ height: '800px', width: '100%' }} />
      <figcaption className="img-caption">NIOSH-OSHA</figcaption>
    </figure>
  );
  const slide2Content = () => (
    <figure className="img-container">
      <img src={slide2} alt="cardinal" style={{ height: '800px', width: '100%' }} />
      <figcaption className="img-caption">Real-time CBT</figcaption>
    </figure>
  );
  const slide3Content = () => (
    <figure className="img-container">
      <img src={slide3} alt="cardinal" style={{ height: '800px', width: '100%' }} />
      <figcaption className="img-caption">W3 Stands Up</figcaption>
    </figure>
  );
  return (
    <div className="home-container">
      <div className="nav-bar-bg">
        <Navbar />
      </div>
      <div className="control-container" style={{ height: '100%', width: '100%' }}>
        <CarouselComponent animationEffect="Fade" enableTouchSwipe={false}>
          <CarouselItemsDirective>
            <CarouselItemDirective template={slide0Content} interval={3000} />
            <CarouselItemDirective template={slide1Content} interval={6000} />
            <CarouselItemDirective template={slide2Content} interval={6000} />
            <CarouselItemDirective template={slide3Content} interval={6000} />
          </CarouselItemsDirective>
        </CarouselComponent>
      </div>
    </div>
  );
};
export default NewHome;
